import { render } from "./DealLines.vue?vue&type=template&id=9dd0f320&scoped=true&ts=true"
import script from "./DealLines.vue?vue&type=script&lang=ts"
export * from "./DealLines.vue?vue&type=script&lang=ts"

import "./DealLines.vue?vue&type=style&index=0&id=9dd0f320&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd0f320"]])

export default __exports__